import { DepthEffect } from 'postprocessing'
import { wrapEffect } from '../util'

export const Depth = wrapEffect(DepthEffect)
